import { Box, Stack, Typography, alpha } from '@mui/material'

const Section = ({ title, hint, children, actions = null }) => (
  <Box
    sx={{
      p: 1.75,
      borderRadius: 2,
      border: (theme) => `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
      backgroundColor: alpha('#000', 0.18)
    }}
  >
    <Stack direction='row' alignItems='flex-start' justifyContent='space-between' gap={1} sx={{ mb: 1.25 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 800, fontSize: '0.9rem' }}>{title}</Typography>
        {hint
          ? (
            <Typography variant='caption' sx={{ color: alpha('#fff', 0.7), display: 'block', mt: 0.25, fontWeight: 600 }}>
              {hint}
            </Typography>
            )
          : null}
      </Box>
      {actions}
    </Stack>
    {children}
  </Box>
)

export { Section }
